/**
 * workflowページの表スクロールバー
 */
import PerfectScrollbar from 'perfect-scrollbar';

/**
 * 初回アクセス時の青いローデイング
 */
export default class workflowScrollbar {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'workflowScrollbar';
    this.init();
  }

  /**
   * 初期化
   */
  init() {
    document.querySelectorAll('.p-workflow__scroll-area').forEach((el, index) => {
      // スクロールバー
      this.ps = new PerfectScrollbar(el, {
        suppressScrollY: true
      });
    });

  }
}
